import { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import get from 'lodash/get';
import { useDriveCNumbersStore } from '../../Store';
import { useStartupDriveStore } from '../../Store/useStartupDriveStore';
import { getDMSProxyFirewallUrl } from '../../util/getDMSProxyUrls';
import { driveLaunchFallback } from '../../util/driveLaunchFallback';
import { MultipleDMSDialog } from '../Dialogs/MultipleDMSDialog';
import { canOpenDrive } from '../../util/DriveUtils';
import { CNumber } from '../../types';

export default function StartupDriveLauncher() {
  const session = useOktaAuth();
  const authToken = get(session, 'authState.idToken.idToken', '');
  const dmsCNumbers = useDriveCNumbersStore((state: any) => state.cNumbers);
  const isFetching = useDriveCNumbersStore((state: any) => state.isFetched);
  const userLocale = localStorage.getItem('userLocale') || 'en_US';
  const shouldLaunchDrive = useStartupDriveStore((state) => state.shouldLaunchDrive);
  const setShouldLaunchDrive = useStartupDriveStore((state) => state.setShouldLaunchDrive);
  const [showMultiDMSDialog, setShowMultiDMSDialog] = useState(false);

  const { url } = getDMSProxyFirewallUrl({
    cNumber: get(dmsCNumbers, [0, 'cNumber']),
    driveToken: authToken,
    lang: userLocale,
  });

  useEffect(() => {
    if (!shouldLaunchDrive) return;
    if (!dmsCNumbers?.length || !url) return;

    setShouldLaunchDrive(false);
    if (!canOpenDrive()) return;

    if (dmsCNumbers.length > 1) {
      console.log('StartupDriveLauncher: multi-DMS, opening dialog');
      setShowMultiDMSDialog(true);
      return;
    }

    console.log('StartupDriveLauncher: launching Drive');
    driveLaunchFallback(url);
  }, [shouldLaunchDrive, dmsCNumbers, url, setShouldLaunchDrive]);

  return (
    <>
      {showMultiDMSDialog && (
        <MultipleDMSDialog
          setDialogOpen={setShowMultiDMSDialog}
          shouldDialogOpen={showMultiDMSDialog}
          dmsCNumbers={dmsCNumbers as CNumber[]}
          isFetching={isFetching}
        />
      )}
    </>
  );
}